export type ApplicationPickerItem =
  | 'separator'
  | {
      id: string;
      name: string;
      icon: string;
      url: string;
      authType?: string;
      postEndpoint?: string;
    };

export const DEFAULT_ITEMS = [
  {
    id: process.env.REACT_APP_TMM_APP_ID || '0b12c499-83ad-4ace-a3bb-98209dbd0911',
    name: 'Maintenance Management',
    icon: 'tools',
    url: '/',
  },
];
